export default "__VITE_ASSET__CwUWHOFS__"